import SuspenseLoading from "components/loading";
import { ReactNode, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { closeLoading } from "state/loading/loadingSlice";

const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();

  const { title, isOpen } = useAppSelector((state) => state.loading);

  useEffect(() => {
    if (isOpen) {
      const timeoutId = setTimeout(() => {
        dispatch(closeLoading());
      }, 15000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [dispatch, isOpen]);

  return (
    <>
      {isOpen && <SuspenseLoading title={title} />}
      {children}
    </>
  );
};

export default LoadingProvider;
